// components/MobileFooter.js
import { Link, useLocation } from "react-router-dom";
import { Home, Truck } from "lucide-react";

const MobileFooter = () => {
  const location = useLocation();

  const menu = [
    { name: "Home", path: "/", icon: <Home size={20} /> },
    { name: "Tow", path: "/tow-clamp", icon: <Truck size={20} /> },
  ];

  return (
    <div style={styles.footer}>
      {menu.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{
            ...styles.link,
            color: location.pathname === item.path ? "#33AE54" : "#777",
          }}
        >
          {item.icon}
          <span style={{ fontSize: "12px" }}>{item.name}</span>
        </Link>
      ))}
    </div>
  );
};

const styles = {
  footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: "60px",
    background: "#fff",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    borderTop: "1px solid #eee",
    zIndex: 1000,
  },
  link: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textDecoration: "none",
  },
};

export default MobileFooter;